import React from 'react';
import { SectionPanel } from 'ui';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { MetroLineSection } from 'app/components/metro-line/metro-line-section';
import { CompanyReportSectionType } from '../metroline/types';
import { CompanyReportSection } from '../types';
import { MetadataContainer } from './metadata-container';

export const Metadata: React.FC<CompanyReportSection> = ({
  companyReportItem, validation, translation, section, getRef, shouldRenderSection, loadOptions, locale, options,
  updateMetadataItem, removeMetadata, addMetadata, removeAllMetadata, resetMetadataValidation
}) =>
  <MetroLineSection<CompanyReportSectionType>
    section={section}
    sectionType={CompanyReportSectionType.Metadata}
    getRef={getRef}
    shouldRenderSection={shouldRenderSection}>
    <div ref={getRef(CompanyReportSectionType.Metadata)}>
      <SectionPanel
        className="admin-paper-top-panel"
        componentId={CompanyReportSectionType.Metadata}
        validation={undefined}
        info={{ text: translation.metadata_title }}
        label={{ visible: true, text: translation.metadata_title }} />
      <MainGridContainer className="mt-3">
        <MetadataContainer
          companyReportItem={companyReportItem}
          validation={validation}
          updateMetadataItem={updateMetadataItem}
          removeMetadata={removeMetadata}
          removeAllMetadata={removeAllMetadata}
          addMetadata={addMetadata}
          resetMetadataValidation={resetMetadataValidation}

          loadOptions={loadOptions}
          locale={locale}
          options={options}
          translation={translation} />

      </MainGridContainer>
    </div>
  </MetroLineSection>;
